/* VERGE 2 preview deck.
 * window.V2_PRESETS = [{num,name,fam,bars,dur,peaks:[0..1 x96],url}]
 * Each preview is the preset playing its own composed clip, rendered straight out of Serum 2 at 120 BPM with the
 * clip starting at 0.1 s. The optional kick is synthesized here and scheduled on that grid, so it lands in time.
 */
(function () {
  var LIST = window.V2_PRESETS || [];
  var deck = document.getElementById('deck');
  if (!deck || !LIST.length) return;

  // each preview carries its render tempo and where beat 1 sits (130 BPM renders start on beat 1 at t=0)
  function beat(p) { return 60 / (p.bpm || 120); }
  function start(p) { return p.start != null ? p.start : 0.1; }
  var ctx = null, master = null, kickBus = null, analyser = null, levelBuf = null, buffers = {}, cur = null;
  var kickOn = false, filter = 'ALL';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var rows = $('.deck__rows', deck), scope = $('.scope canvas', deck);
  var nowName = $('.now__name', deck), nowMeta = $('.now__meta', deck), nowNum = $('.now__num', deck);
  var kickBtn = $('.kick', deck), playBtn = $('.now__play', deck);

  /* scope colours come from the page's CSS (--scope-hot/-cold/-line/-trail/-head on #deck), so every design can
     restyle the waveform; the defaults are the EVENT HORIZON gold */
  var css = getComputedStyle(deck);
  function v(name, d) { var x = css.getPropertyValue(name).trim(); return x || d; }
  var COL = {
    hot: v('--scope-hot', '#ffd060'), cold: v('--scope-cold', 'rgba(255,232,190,.22)'),
    line: v('--scope-line', 'rgba(255,195,50,.9)'), trail: v('--scope-trail', 'rgba(255,240,190,.55)'),
    head: v('--scope-head', '#fff8e6')
  };

  /* iPhone: Web Audio is muted by the ring/silent switch unless the page's audio session is 'playback'.
     iOS 17+ exposes navigator.audioSession; older iOS switches to playback once a media element plays,
     so a silent looping <audio> is started from the same tap. Both must run inside the user gesture. */
  var unlockEl = null;
  function unlockIOS() {
    try { if (navigator.audioSession) { navigator.audioSession.type = 'playback'; return; } } catch (e) {}
    if (unlockEl) return;
    unlockEl = document.createElement('audio');
    unlockEl.setAttribute('x-webkit-airplay', 'deny');
    unlockEl.setAttribute('playsinline', '');
    unlockEl.loop = true;
    unlockEl.src = 'data:audio/wav;base64,UklGRrQBAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YZABAACAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA';
    var pr = unlockEl.play(); if (pr && pr.catch) pr.catch(function () {});
  }

  function ensureCtx() {
    unlockIOS();
    if (ctx) return ctx;
    var AC = window.AudioContext || window.webkitAudioContext;
    ctx = new AC();
    master = ctx.createGain(); master.gain.value = 0.9; master.connect(ctx.destination);
    analyser = ctx.createAnalyser(); analyser.fftSize = 1024; master.connect(analyser);
    levelBuf = new Float32Array(analyser.fftSize);
    kickBus = ctx.createGain(); kickBus.gain.value = 0.55; kickBus.connect(master);
    return ctx;
  }

  function load(p) {
    if (buffers[p.num]) return buffers[p.num];
    buffers[p.num] = fetch(p.url).then(function (r) { return r.arrayBuffer(); })
      .then(function (ab) { return new Promise(function (ok, no) { ctx.decodeAudioData(ab, ok, no); }); });
    return buffers[p.num];
  }

  /* a short techno kick: pitch-dropping sine + click, a little saturation */
  function kickAt(t) {
    var o = ctx.createOscillator(), g = ctx.createGain(), sh = ctx.createWaveShaper();
    var curve = new Float32Array(256);
    for (var i = 0; i < 256; i++) { var x = i / 128 - 1; curve[i] = Math.tanh(2.2 * x); }
    sh.curve = curve;
    o.type = 'sine';
    o.frequency.setValueAtTime(165, t);
    o.frequency.exponentialRampToValueAtTime(52, t + 0.07);
    o.frequency.exponentialRampToValueAtTime(42, t + 0.3);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(1.0, t + 0.002);
    g.gain.setTargetAtTime(0.0001, t + 0.09, 0.08);
    o.connect(sh); sh.connect(g); g.connect(cur && cur.kick ? cur.kick : kickBus);
    o.start(t); o.stop(t + 0.6);
  }

  function stop() {
    if (!cur) return;
    try { cur.src.stop(); } catch (e) {}
    if (cur.kick) { cur.kick.gain.setTargetAtTime(0, ctx.currentTime, 0.01); }
    cur.row.classList.remove('is-on');
    cur = null;
    playBtn.setAttribute('aria-label', 'Play'); playBtn.classList.remove('is-on');
    deck.classList.remove('is-playing');
    document.documentElement.classList.remove('v2-playing');
  }

  function play(p, row) {
    ensureCtx();
    if (ctx.state === 'suspended') ctx.resume();
    if (cur && cur.p === p) { stop(); return; }
    stop();
    show(p);
    row.classList.add('is-loading');
    load(p).then(function (buf) {
      row.classList.remove('is-loading');
      var src = ctx.createBufferSource(); src.buffer = buf; src.connect(master);
      var t0 = ctx.currentTime + 0.06;
      var kick = ctx.createGain(); kick.gain.value = kickOn ? 1 : 0; kick.connect(kickBus);
      cur = { p: p, row: row, src: src, t0: t0, dur: buf.duration, kick: kick };
      for (var b = 0; b < p.bars * 4; b++) kickAt(t0 + start(p) + b * beat(p));
      src.start(t0);
      src.onended = function () { if (cur && cur.src === src) stop(); };
      row.classList.add('is-on');
      playBtn.setAttribute('aria-label', 'Stop'); playBtn.classList.add('is-on');
      deck.classList.add('is-playing');
      document.documentElement.classList.add('v2-playing');
    }).catch(function () { row.classList.remove('is-loading'); });
  }

  function show(p) {
    nowNum.textContent = p.num;
    nowName.textContent = p.name;
    nowMeta.textContent = label(p.fam) + ' · ' + p.bars + '-bar clip';
    scope.__p = p;
    drawScope(0);
  }

  /* big scope: mirrored peak bars, played part burns hot */
  function drawScope(frac) {
    var p = scope.__p; if (!p) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = scope.clientWidth, h = scope.clientHeight;
    if (scope.width !== Math.round(w * dpr)) { scope.width = Math.round(w * dpr); scope.height = Math.round(h * dpr); }
    var c = scope.getContext('2d');
    c.setTransform(dpr, 0, 0, dpr, 0, 0);
    c.clearRect(0, 0, w, h);
    var n = p.peaks.length, bw = w / n, mid = h / 2;
    for (var i = 0; i < n; i++) {
      var v = Math.max(0.02, p.peaks[i]) * (h * 0.46);
      var hot = (i + 0.5) / n <= frac;
      c.fillStyle = hot ? COL.hot : COL.cold;
      c.fillRect(i * bw + 1, mid - v, Math.max(1, bw - 2), v * 2);
    }
    c.fillStyle = COL.line;
    c.fillRect(0, mid - 0.5, w, 1);
    if (frac > 0) {
      var x = frac * w;
      if (COL.trail !== 'none') {
        var g = c.createLinearGradient(x - 40, 0, x, 0);
        g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, COL.trail);
        c.fillStyle = g; c.fillRect(x - 40, 0, 40, h);
      }
      c.fillStyle = COL.head; c.fillRect(x - 1, 0, 2, h);
    }
  }

  /* the page can react to the sound: --lvl on <html> follows the output level (0..1), html.v2-playing while playing */
  var lvl = 0, root = document.documentElement;
  function meter() {
    var target = 0;
    if (cur && analyser) {
      analyser.getFloatTimeDomainData(levelBuf);
      var s = 0;
      for (var i = 0; i < levelBuf.length; i++) s += levelBuf[i] * levelBuf[i];
      target = Math.min(1, Math.pow(Math.sqrt(s / levelBuf.length) * 2.2, 1.6));   // curve so kick hits flare and tails fall back
    }
    lvl += (target - lvl) * (target > lvl ? 0.5 : 0.12);    // fast attack, slower release
    if (lvl < 0.002) lvl = 0;
    root.style.setProperty('--lvl', lvl.toFixed(3));
  }

  function tick() {
    if (cur) {
      var f = Math.min(1, Math.max(0, (ctx.currentTime - cur.t0) / cur.dur));
      drawScope(f);
      var bar = cur.row.querySelector('.row__prog');
      if (bar) bar.style.transform = 'scaleX(' + f + ')';
    }
    meter();
    requestAnimationFrame(tick);
  }

  function label(fam) { return fam.charAt(0) + fam.slice(1).toLowerCase(); }   /* BASS -> Bass */

  function miniWave(peaks) {
    var n = peaks.length, d = '';
    for (var i = 0; i < n; i++) {
      var v = Math.max(0.04, peaks[i]) * 11;
      d += 'M' + (i * 2 + 1) + ' ' + (12 - v).toFixed(1) + 'V' + (12 + v).toFixed(1);
    }
    return '<svg class="row__wave" viewBox="0 0 ' + (n * 2) + ' 24" preserveAspectRatio="none" aria-hidden="true"><path d="' + d + '"/></svg>';
  }

  LIST.forEach(function (p, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'row';
    b.dataset.fam = p.fam;
    b.setAttribute('aria-label', 'Play ' + p.name + ', ' + p.fam.toLowerCase());
    b.innerHTML =
      '<span class="row__num">' + p.num + '</span>' +
      '<span class="row__name">' + p.name + '</span>' +
      '<span class="row__fam fam-' + p.fam.toLowerCase() + '">' + label(p.fam) + '</span>' +
      miniWave(p.peaks) +
      '<span class="row__icon" aria-hidden="true"></span>' +
      '<span class="row__prog" aria-hidden="true"></span>';
    b.addEventListener('click', function () { play(p, b); });
    rows.appendChild(b);
    if (i === 0) show(p);
  });

  playBtn.addEventListener('click', function () {
    if (cur) { stop(); return; }
    var p = scope.__p, row = null;
    [].some.call(rows.children, function (r, i) { if (LIST[i] === p) { row = r; return true; } });
    if (p && row) play(p, row);
  });

  kickBtn.addEventListener('click', function () {
    kickOn = !kickOn;
    kickBtn.setAttribute('aria-pressed', kickOn ? 'true' : 'false');
    if (cur && cur.kick && ctx) cur.kick.gain.setTargetAtTime(kickOn ? 1 : 0, ctx.currentTime, 0.01);
  });

  [].forEach.call(deck.querySelectorAll('.chip'), function (c) {
    c.addEventListener('click', function () {
      filter = c.dataset.f;
      [].forEach.call(deck.querySelectorAll('.chip'), function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      [].forEach.call(rows.children, function (r) { r.hidden = !(filter === 'ALL' || r.dataset.fam === filter); });
    });
  });

  window.addEventListener('resize', function () { drawScope(0); });
  requestAnimationFrame(tick);

  /* for buttons elsewhere on the page: V2Player.toggle() plays/stops the selected preset, V2Player.family('BASS')
     filters the list and selects its first preset */
  window.V2Player = {
    toggle: function () { playBtn.click(); },
    family: function (fam) {
      var chip = deck.querySelector('.chip[data-f="' + fam + '"]');
      if (chip) chip.click();
      var i = -1;
      LIST.some(function (p, k) { if (fam === 'ALL' || p.fam === fam) { i = k; return true; } });
      if (i >= 0 && !(cur && cur.p === LIST[i])) { stop(); show(LIST[i]); }
    }
  };
})();
